import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes';
import Table from "../../../../core/common/dataTable/index";
import CollapseHeader from '../../../../core/common/collapse-header/collapse-header';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../core/data/redux/store';
import { createLeaveRequest, deleteLeaveRequest, fetchLeaveRequestByEmployeeId } from '../../../../core/data/redux/attendance/leave/leaveAction';
import DeleteModal1 from '../../../../core/modals/deleteModal1';
import { formatDate } from "../../../../core/utils/configFormatters";
import { getEmployeeByUserId } from '../../../../core/data/redux/employee/employeeAction';
import { filterData } from '../../../../core/common/GlobalFunctions/tableFilters';
import { exportToCSV, exportToExcel, exportToPDF } from '../../../../core/common/GlobalFunctions/exportTableData';
import LeaveRequestModal from './leaveRequestModal';
import { Drawer, message } from 'antd';
import { fetchAllLeaveCountByEmployeeId } from '../../../../core/data/redux/reports/leave_reports/leavereports.Action';
import { useAppConfig } from '../../../../customhooks/useAppConfig';
import { fetchEmployeeLeaveAssignById } from '../../../../core/data/redux/attendance/leave/leaveAction';
import { decryptData } from '../../../../core/utils/encryptUtils';
import { fetchAllWeekoff } from '../../../../core/data/redux/weekoff/weekoff.Action';
import dayjs, { Dayjs } from "dayjs";
import LeaveCancellationForm from './leavecancellation';
import { buildEmployeeWeeklyOffMap, isWeeklyOffDate, isHolidayInRange } from '../weeklyOffUtils';
import { fetchAllHolidays } from '../../../../core/data/redux/holiday/holidayAction';
import { useAILeaveActions } from '../../../../core/AiActions/leaveAiFunction';


const LeaveEmployee = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const { weekoff } = useSelector((state: any) => state.weekoff);
  const { holidays = [], loading } = useSelector((state: any) => state.holiday);
  const [isTodayWeeklyOff, setIsTodayWeeklyOff] = useState(false);
  const leaveRequestId = Number(selectedRowData?.Id);
  const employeeId = employeesbyUser?.employeeId;
  const [count, setcount] = useState<any>("")
  const { employeeLeaveRequest } = useSelector((state: any) => state.attendance.leaveRequests);
  const [employeeassignleave, setemployeeassignleave] = useState<any>([])
  const [isCancellationModalVisible, setIsCancellationModalVisible] = useState(false);


  useEffect(() => {
    if (employeeId && !employeeLeaveRequest.length) {
      dispatch(fetchLeaveRequestByEmployeeId(employeeId))
    }
    if (!employeesbyUser?.employeeId) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
    if (employeeId) {
      dispatch(fetchEmployeeLeaveAssignById(employeeId))
        .then((res) => {
          setemployeeassignleave(res.payload.data)
        })
      dispatch(fetchAllLeaveCountByEmployeeId(employeeId))
        .then((res) => {
          setcount(res?.payload?.data)
        })
    }
  }, [dispatch, employeeId, isModalVisible, isCancellationModalVisible])

  useEffect(() => {
    dispatch(fetchAllWeekoff());
  }, [dispatch]);

  useEffect(() => {
    if (!holidays.length) {
      dispatch(fetchAllHolidays());
    }
  }, [dispatch, holidays.length]);


  const [cancellationForm, setCancellationForm] = useState<{
    LeaveTypeId: string | number;
    LeaveId: string | number;
    FromDate: Dayjs | null;
    ToDate: Dayjs | null;
    Duration: string | number;
    RemainingDays: string | number;
    Reason: string;
    LeaveMode: string;
    CancellationReason: string;
  }>({
    LeaveTypeId: "",
    LeaveId: "",
    FromDate: null,
    ToDate: null,
    Duration: "",
    RemainingDays: "",
    Reason: "",
    LeaveMode: "",
    CancellationReason: "",
  });

  useEffect(() => {
    if (selectedRowData) {
      const today = dayjs();
      let fromDate = dayjs(selectedRowData.FromDate);
      const toDate = dayjs(selectedRowData.ToDate);

      if (today.isSameOrAfter(fromDate, "day") && today.isSameOrBefore(toDate, "day")) {
        fromDate = today;
      }

      const duration = toDate.diff(fromDate, "day") + 1;

      setCancellationForm((prev) => ({
        ...prev,
        LeaveTypeId: selectedRowData.LeaveTypeId || "",
        LeaveId: selectedRowData.Id || "",
        FromDate: selectedRowData.FromDate
          ? dayjs(selectedRowData.FromDate)
          : null,
        ToDate: selectedRowData.ToDate ? dayjs(selectedRowData.ToDate) : null,
        Duration: selectedRowData.Duration || "",
        RemainingDays: count?.RemainingDays || "",
        Reason: selectedRowData.Description || "",
        LeaveMode: selectedRowData.LeaveMode || "",
      }));
    }
  }, [selectedRowData, count]);

  const handleFormChange = (field: string, value: any) => {
    setCancellationForm((prev) => ({ ...prev, [field]: value }));
  };

  const employeeWeeklyOffMap = useMemo(
    () => buildEmployeeWeeklyOffMap(weekoff, employeesbyUser),
    [weekoff, employeesbyUser]
  );


  useEffect(() => {
    if (!employeeId) return;

    const today = dayjs();
    const dayLabel = today.format("dddd");
    const weekIndex = Math.floor((today.date() - 1) / 7) + 1;
    const empWeeks = employeeWeeklyOffMap[employeeId];

    const isOff = empWeeks?.get(dayLabel)?.has(weekIndex) ?? false;
    setIsTodayWeeklyOff(isOff);
  }, [employeeId, employeeWeeklyOffMap]);


  const checkWeeklyOffRange = (fromDate: Dayjs, toDate: Dayjs) => {
    let current = fromDate.startOf("day");
    while (current.isSameOrBefore(toDate, "day")) {
      if (isWeeklyOffDate(current, employeeId, employeeWeeklyOffMap)) {
        return { isInvalid: true, type: "WeeklyOff" };
      }
      current = current.add(1, "day");
    }

    // 🔹 Check for holiday overlap
    if (isHolidayInRange(fromDate, toDate, holidays)) {
      return { isInvalid: true, type: "Holiday" };
    }

    return { isInvalid: false, type: "" };
  };


  const showModal = (type: 'edit' | 'create') => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType('');
    setIsCancellationModalVisible(false);
  };

  const handleEditlevaeRequest = (record: any): void => {
    setSelectedRowData(record)
  }

  //Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");



  const handleDeleteLeave = async (designationId: number) => {
    try {
      const result = await dispatch(deleteLeaveRequest(designationId));
      if (result.meta.requestStatus === 'fulfilled') {
        message.success('Leave deleted successfully');
        setIsDeleteModalVisible(false);
        await dispatch(fetchLeaveRequestByEmployeeId(employeeId))
        setTableKey((prevKey) => prevKey + 1);
      } else {
        message.error(result.payload.error);
      }
    } catch (error) {
      message.error('Something went wrong');
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const data = employeeLeaveRequest ? employeeLeaveRequest : [];
  const filteredData = useMemo(() => {

    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { LeaveRequestStatus: selectedStatus }
        : {};
    return filterData(data || [], filters, "CreatedAt", "CreatedAt", selectedSort);
  }, [data, selectedStatus, selectedSort]);


  const exportLeaveEmployee = data.map((item: any) => ({
    LeaveType: item.LeaveType || "N/A",
    FromDate: item.FromDate ? new Date(item.FromDate).toLocaleDateString("en-IN") : "N/A",
    ToDate: item.ToDate ? new Date(item.ToDate).toLocaleDateString("en-IN") : "N/A",
    Duration: item.Duration || "N/A",
    ApprovedBy: item.ApprovedBy || "Pending",
    LeaveRequestStatus: item.LeaveRequestStatus || "Pending",
    Reason: item.Description || "N/A",
    LeaveMode: item.LeaveMode || "N/A",
  }));


  useEffect(() => {
    setTableKey(prevKey => prevKey + 1);
  }, [selectedStatus, selectedSort, employeeLeaveRequest, isCancellationModalVisible]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Leave Type",
      dataIndex: "LeaveType",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center">
          <p className="fs-14 fw-medium d-flex align-items-center mb-0">
            {record.LeaveType}
          </p>
          {/* <Link
            to="#"
            className="ms-2"
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            data-bs-title="I am currently experiencing a fever and feeling unwell."
          >
            <i className="ti ti-info-circle text-info" />
          </Link> */}
        </div>
      ),
      sorter: (a: any, b: any) => a.LeaveType.length - b.LeaveType.length,
    },
    {
      title: "From",
      dataIndex: "FromDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.FromDate.length - b.FromDate.length,
    },

    {
      title: "To",
      dataIndex: "ToDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.ToDate.length - b.ToDate.length,
    },

    {
      title: "No of Days",
      dataIndex: "Duration",
      sorter: (a: any, b: any) => a.Duration.length - b.Duration.length,
    },
    {
      title: "Status",
      dataIndex: "LeaveRequestStatus",
      render: (text: string, record: any) => {
        const badgeClass =
          text === "Pending"
            ? "badge-warning"
            : text === "Approved"
              ? "badge-success"
              : text === "Rejected"
                ? "badge-danger"
                : text === "Cancelled"
                  ? "badge-secondary"
                  : "";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        );
      },
    },
    {
      title: "Cancellation_Status",
      dataIndex: "Cancellation_status",
      render: (text: string) => {
        const badgeClass =
          text === "Pending"
            ? "badge-warning"
            : text === "Approved"
              ? "badge-success"
              : text === "Rejected"
                ? "badge-danger"
                : "";

        return (
          <span
            className={`badge ${badgeClass} d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text || "N/A"}
          </span>
        );
      },
      sorter: (a: any, b: any) =>
        (a.Cancellation_status || "").localeCompare(b.Cancellation_status || ""),
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const today = dayjs();

        const canCancel =
          record.LeaveRequestStatus === "Approved" &&
          !["Pending", "Approved", "Rejected"].includes(record.Cancellation_status) &&
          (
            // Before Leave Start Date
            (today.isSameOrBefore(dayjs(record.ToDate), "day") &&
              today.isBefore(dayjs(record.FromDate), "day")) ||

            // During Leave Dates
            (today.isSameOrAfter(dayjs(record.FromDate), "day") &&
              today.isSameOrBefore(dayjs(record.ToDate), "day"))
          );

        return (
          <div className="action-icon d-inline-flex">
            {/* Edit Button */}
            <button
              className="me-2"
              onClick={() => {
                if (!canEdit || record.LeaveRequestStatus === "Approved") return;
                showModal("edit");
                handleEditlevaeRequest(record);
              }}
              disabled={!canEdit || record.LeaveRequestStatus === "Approved" || record.LeaveRequestStatus === "Cancelled"}
              style={{
                cursor:
                  !canEdit || record.LeaveRequestStatus === "Approved"
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  !canEdit || record.LeaveRequestStatus === "Approved" ? 0.5 : 1,
                border: "none",
                background: "transparent",
              }}
              title="Edit"
            >
              <i className="ti ti-edit" />
            </button>

            {/* Delete Button */}
            <button
              onClick={() => {
                if (!canDelete || record.LeaveRequestStatus === "Approved") return;
                setSelectedRowData(record);
                setIsDeleteModalVisible(true);
              }}
              className="me-2"
              disabled={!canDelete || record.LeaveRequestStatus === "Approved" || record.LeaveRequestStatus === "Cancelled"}
              style={{
                cursor:
                  !canDelete || record.LeaveRequestStatus === "Approved"
                    ? "not-allowed"
                    : "pointer",
                opacity:
                  !canDelete || record.LeaveRequestStatus === "Approved" ? 0.5 : 1,
                border: "none",
                background: "transparent",
              }}
              title="Delete Request"
            >
              <i className="ti ti-trash" />
            </button>

            {/* Cancellation Button */}
            {/* Cancellation Button */}
            <button
              onClick={() => {
                if (!canCancel) return;
                setSelectedRowData(record);
                setIsCancellationModalVisible(true);
              }}
              disabled={!canCancel}
              style={{
                cursor: canCancel ? "pointer" : "not-allowed",
                border: "none",
                background: "transparent",
                padding: 0,
                opacity: canCancel ? 1 : 0.5,
              }}
              title={
                !canCancel
                  ? record.Cancellation_status === "Pending"
                    ? "Cancellation request already submitted"
                    : record.Cancellation_status === "Approved"
                      ? "Cancellation already approved"
                      : "Cancellation not allowed"
                  : "Request Cancellation"
              }
            >
              <i
                className="fa-solid fa-ban text-grey"
                style={{ fontSize: "16px", width: "16px", height: "16px" }}
              ></i>
            </button>

          </div>
        );
      },
    },
  ]

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Leaves</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendances</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Leaves
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportLeaveEmployee, 'leave_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportLeaveEmployee, 'leave_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportLeaveEmployee, 'leave_data')}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    onClick={() => showModal('create')}
                    className="btn btn-primary d-flex align-items-center"
                    title={isTodayWeeklyOff ? "Today is your weekly off" : "Add Leave"}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    {isTodayWeeklyOff ? "Today is your weekly off" : "Add Leave"}
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Leaves Info */}
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div className="card bg-black-le">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-start">
                      <p className="mb-1">Total Leaves</p>
                      <h4>{count ? count?.[0].Total : 0}</h4>
                    </div>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md d-flex">
                          <i className="ti ti-calendar-event fs-32" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="badge bg-secondary-transparent">

                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-blue-le">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Approved Leaves
                      </p>
                      <h4>{count ? count?.[0].Approved : 0}</h4>
                    </div>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md d-flex">
                          <i className="ti ti-vaccine fs-32" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="badge bg-info-transparent">

                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-purple-le">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Pending Requests
                      </p>
                      <h4>{count ? count?.[0].Pending : 0}</h4>
                    </div>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md d-flex">
                          <i className="ti ti-hexagon-letter-c fs-32" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="badge bg-transparent-purple">

                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6">
              <div className="card bg-pink-le">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="fs-12 fw-normal mb-1 text-truncate">
                        Rejected Leaves
                      </p>
                      <h4>{count ? count?.[0].Rejected : 0}</h4>
                    </div>
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-2">
                        <span className="avatar avatar-md d-flex">
                          <i className="ti ti-hexagonal-prism-plus fs-32" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <span className="badge bg-pink-transparent">

                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* /Leaves Info */}
          {/* Leaves list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Leaves List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus ? selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1) : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Pending')}
                        className="dropdown-item rounded-1"
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Approved')}
                        className="dropdown-item rounded-1"
                      >
                        Approved
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus('Rejected')}
                        className="dropdown-item rounded-1"
                      >
                        Rejected
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort ? `Sort By : ${selectedSort}` : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Recently Added")} className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Ascending")} className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Descending")} className="dropdown-item rounded-1">
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last Month")} className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => setSelectedSort("Last 7 Days")} className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table key={tableKey} dataSource={filteredData} columns={columns} Selection={true} />
            </div>
          </div>
          {/* /Leaves list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}

      <Drawer
        title="Cancel Leave"
        placement="right"
        open={isCancellationModalVisible}
        onClose={() => setIsCancellationModalVisible(false)}
        width={500}
      >
        <LeaveCancellationForm
          selectedRowData={selectedRowData}
          count={count}
          onClose={() => setIsCancellationModalVisible(false)}
        />

      </Drawer>


      {/* Add Leaves */}
      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() => selectedRowData?.Id && handleDeleteLeave(selectedRowData.Id)}
      />
      <LeaveRequestModal modalType={modalType} isModalVisible={isModalVisible} handleCancel={handleCancel} employeeId={employeeId} setTableKey={setTableKey} leaveRequestId={leaveRequestId} selectedRowData={selectedRowData} employeeassignleave={employeeassignleave} checkWeeklyOffRange={checkWeeklyOffRange} />
    </>
  )
}

export default LeaveEmployee
